import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getModuleCrud } from "../utils/appRole";

/**
 * Module CRUD flags from Redux account access (GET /api/account/access).
 * @param {string} moduleKey e.g. cameras, users, roles, zones, ai_models, rules
 */
export function useModuleCrudPermissions(moduleKey) {
  const accountAccess = useSelector((state) => state.auth.accountAccess);
  const accessLoaded = useSelector((state) => state.auth.accessLoaded);

  return useMemo(() => {
    const crud = getModuleCrud(accountAccess, moduleKey);
    return {
      ...crud,
      accessLoaded,
      hasRowActions: crud.update || crud.delete,
    };
  }, [accountAccess, accessLoaded, moduleKey]);
}
